import { Edit, ReferenceInput, SelectInput, SimpleForm, TextField, Labeled } from "react-admin";

// Админ может сменить/снять привязку промокода у пользователя (пользователь сам — не может).
export function PromoBindingEdit() {
  return (
    <Edit redirect="list" mutationMode="pessimistic">
      <SimpleForm>
        <Labeled label="Пользователь"><TextField source="username" /></Labeled>
        <Labeled label="Телефон"><TextField source="phone" /></Labeled>
        <ReferenceInput source="promo_code_id" reference="promo-codes">
          <SelectInput
            label="Промокод"
            optionText="code"
            emptyText="— снять привязку —"
            helperText="Пусто — отвязать (заблокирует USDT-операции)"
          />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
}
